import { TableGroupExpansionsValue } from '../../store/states/tableGroupExpansions';

type UserGroupSelection = {
  colId: string;
  level: number;
};

export const isDataRowVisible = (
  userGroupSelection: UserGroupSelection[],
  tableGroupExpansions: Record<string, TableGroupExpansionsValue>
) => {
  const maxGroupLevel = userGroupSelection.reduce((max, column) => {
    return Math.max(max, column.level ?? -1);
  }, -1);

  const expandedGroups = Object.entries(tableGroupExpansions)
    .filter(([_, expansion]) => expansion.expanded === true)
    .map(([groupId, expansion]) => ({
      id: groupId,
      level: expansion.groupLevel,
    }));

  const rootLevelExpansions = expandedGroups.filter(
    (group) => group.level === 0
  );

  // Shortcut
  if (rootLevelExpansions.length > 0 && maxGroupLevel <= 0) {
    return true;
  }

  for (const rootGroup of rootLevelExpansions) {
    const secondLevelExpansions = expandedGroups.filter(
      (g) => g.level === 1 && g.id.startsWith(rootGroup.id)
    );

    if (secondLevelExpansions.length > 0 && maxGroupLevel <= 1) {
      return true;
    }

    for (const secondGroup of secondLevelExpansions) {
      const thirdLevelExpansions = expandedGroups.filter(
        (g) => g.level === 2 && g.id.startsWith(secondGroup.id)
      );

      if (thirdLevelExpansions.length > 0 && maxGroupLevel <= 2) {
        return true;
      }
    }
  }

  return false;
};
